<template>
  <div>
    <div class="w-full bg-white dropdown">
      <div class="container mx-auto">
        <div class="grid" v-bind:class="{'lg:grid-cols-4': secondary && secondary.length > 0,  '': !secondary && secondary.length > 0}">
          <div class="grid lg:col-span-3 dropdown-images px-8">
            <ul class="grid grid-cols-3 multiline">
              <li v-for="subMenu in primary" :key="subMenu.id" @click="hideDropdown()">
                <NuxtLink :to="subMenu.slug">
                  <img
                    v-if="subMenu.image"
                    :src="imageLocation + subMenu.image"
                    :alt="subMenu.name"
                    class="rounded-3xl"
                    loading="lazy"
                  />
                  {{ subMenu.name }}
                </NuxtLink>
              </li>
            </ul>
          </div>
          <div class="menu-border-left dropdown-list" v-if="secondary && secondary.length > 0">
            <h3 class="mb-6" v-text="menu.secondary_child_menu_items_title"></h3>
            <ul class="grid grid-cols-1 multiline">
              <li v-for="subMenu in secondary" :key="subMenu.id" @click="hideDropdown()">
                <NuxtLink :to="subMenu.slug" > {{ subMenu.name }} </NuxtLink>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div v-if="menu.name == 'Pest Control' && menu.disclaimer != null" class="container mx-auto text-left">
        <p>{{menu.disclaimer}}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, toRefs } from 'vue';
import {useNuxtApp} from '#app';
// Props
const props = defineProps({
  menu: Object
});

// Access Nuxt.js runtime config
const {$config} = useNuxtApp();

// Reactive state
const imageLocation = ref($config.public.sgCmsImage);
const { primary, secondary } = toRefs(props.menu);

// Methods

const emit = defineEmits(['hideDropdown']);

const hideDropdown = () => {
  emit('hideDropdown');
};
</script>

<style scoped>
.menu .dropdown {
  left: 0;
  top: 104px;
  border-bottom-left-radius: 26px;
  border-bottom-right-radius: 26px;
  padding: 30px;
  position: absolute;
  display: none;
  box-shadow: 0px 14px 14px rgba(0, 0, 0, 0.25);
}

.mobile .dropdown {
  display: none;
}

.menu li:hover .dropdown, .mobile li:hover .dropdown, .mobile li:active .dropdown {
  display: block;
}

.dropdown-list ul {
  margin: 0;
  padding: 0;
}

.dropdown-list li {
  margin: 10px 0;
  padding: 0;
  list-style: none;
}

.dropdown a {
  font-weight: bold;
}

.dropdown-images ul {
  margin: 0;
  padding: 0;
}

.dropdown-images li {
  margin: 0 0 20px;
  padding: 5px;
  list-style: none;
  text-align: center;
}

.dropdown-images img {
  width: 90%;
  height: auto;
  margin: 0 auto 5px;
  border: 2px solid #4DA43A;
  padding: 2px;
}

.services-pest-services- .dropdown-images img {
  border: 2px solid #e47907;
}

.menu .menu-border-left {
  border-left: 1px solid #abbdc8;
  padding-left: 40px;
}

.mobile .menu-border-left h3 {
  border-bottom: 1px solid #abbdc8;
  padding-bottom: 20px;
}

</style>
